module.exports = __webpack_public_path__ + "assets/img/icon-cp.f9ba08b8.png";